import styled from "styled-components";

const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px 20px;
  min-height: 36px;
`;

const Heading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 20px;
  font-weight: 650;
  line-height: 1.25;
  letter-spacing: -0.015em;
  color: ${(props) => props.theme.textColor};
`;

const Description = styled.div`
  font-size: 13.5px;
  color: ${(props) => props.theme.secondaryTextColor};
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;

const PageHeader: React.FC<{
  title: React.ReactNode;
  description?: React.ReactNode;
  // Small element next to the title, typically a count Badge
  badge?: React.ReactNode;
  // Controls on the right side of the header
  actions?: React.ReactNode;
}> = ({ title, description, badge, actions }) => {
  return (
    <Header>
      <Heading>
        <TitleRow>
          <Title>{title}</Title>
          {badge}
        </TitleRow>
        {description && <Description>{description}</Description>}
      </Heading>
      {actions && <Actions>{actions}</Actions>}
    </Header>
  );
};
export default PageHeader;
